
window.appointmentReminder = {
  handler: {}
};

appointmentReminder.ready = function() {
  const preview = document.getElementById('preview-enriched-message');
  const fields = [
    { name: 'appointment_date', placeholder: '{{appointment_date}}', regex: /{{\s*appointment_date\s*}}/g },
    { name: 'appointment_time', placeholder: '{{appointment_time}}', regex: /{{\s*appointment_time\s*}}/g }
  ];

  function getFieldValue(field) {
    const el = document.querySelector(`input[name="${field.name}"]`);
    return el ? el.value : '';
  }

  function handleInput() {
    if (!preview) return;
    let content = preview.dataset.template;
    fields.forEach(field => {
      const value = getFieldValue(field) || field.placeholder;
      content = content.replace(field.regex, value);
    });
    preview.textContent = content;
  }

  function init() {
    console.log("Initializing appointment reminder handler");
    fields.forEach(field => {
      const el = document.querySelector(`input[name="${field.name}"]`);
      if (el) el.addEventListener('input', handleInput);
    });
    if (preview && !preview.dataset.template) {
      preview.dataset.template = preview.textContent;
    }
  }

  appointmentReminder.handler = { handleInput, init };
  appointmentReminder.handler.init();
};
